@if (waitingForFilterResults) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="list-header">
  <h1 class="page-title">{{ entityTypeName }}</h1>

  <div class="filter-container">
    <mat-button-toggle-group
      (change)="userChangedFilter($event)"
      multiple="true">
      <mat-button-toggle
        value="Owner"
        [checked]="isFilterActive(MyWorkFilter.Owner)">
        I am the Owner
      </mat-button-toggle>
      <mat-button-toggle
        value="ExpiringSoon"
        [checked]="isFilterActive(MyWorkFilter.ExpiringSoon)">
        Expiring Soon (6 months)
      </mat-button-toggle>
      <mat-button-toggle
        value="Expired"
        [checked]="isFilterActive(MyWorkFilter.Expired)">
        Already Expired
      </mat-button-toggle>
      <mat-button-toggle
        value="NextReviewDateSoon"
        [checked]="isFilterActive(MyWorkFilter.NextReviewDateSoon)">
        Next Review Date Soon (6 months)
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <span class="item-count">{{ filteredContracts.length }} contracts</span>
</div>

<div class="table-container">
  <table mat-table [dataSource]="filteredContracts" matSort (matSortChange)="sortData($event)" class="entity-table">

    <!-- Status Column (icon) -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let contract" class="status-cell">
        @if (isExpired(contract)) {
          <mat-icon class="status-icon expired" matTooltip="Expired">error</mat-icon>
        } @else if (isExpiringSoon(contract)) {
          <mat-icon class="status-icon expiring-soon" matTooltip="Expiring within 6 months">warning</mat-icon>
        } @else {
          <mat-icon class="status-icon active" matTooltip="Active">check_circle</mat-icon>
        }
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="nameOfContract">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let contract" class="name-cell">
        <span class="contract-name">{{ contract.nameOfContract || '—' }}</span>
        @if (contract.contractId) {
          <span class="contract-num-badge">{{ contract.contractId }}</span>
        }
      </td>
    </ng-container>

    <!-- Party Column -->
    <ng-container matColumnDef="directVendor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Party</th>
      <td mat-cell *matCellDef="let contract">{{ extractVendorName(contract.directVendor) }}</td>
    </ng-container>

    <!-- Primary Owner Column -->
    <ng-container matColumnDef="primaryOwner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary Owner</th>
      <td mat-cell *matCellDef="let contract">{{ extractOwnerName(contract.primaryOwner) }}</td>
    </ng-container>

    <!-- Status Field Column -->
    <ng-container matColumnDef="status_field">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let contract">
        @if (contract.status) {
          <span class="status-chip">{{ contract.status }}</span>
        }
      </td>
    </ng-container>

    <!-- Expiration Date Column -->
    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
      <td mat-cell *matCellDef="let contract"
          [class.overdue-text]="isExpired(contract)"
          [class.due-soon-text]="isExpiringSoon(contract)">
        {{ formatDate(contract.expirationDate) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="entity-row"
        (click)="onRowClicked(row)">
    </tr>

    <!-- No data row -->
    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-data-message">
          @if (isLoading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Loading contracts...</p>
          } @else {
            <mat-icon>description</mat-icon>
            <p>No contracts found</p>
          }
        </div>
      </td>
    </tr>
  </table>
</div>
